import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledMainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center', // Center content vertically
  padding: theme.spacing(1),
  height: '100%', // Fill the available space inside iframe
  width: '100%', // Make sure it fits the iframe
  minHeight: '650px', // Prevent scrolling
  borderRadius: 10,
  border: '5px solid #0eaec1',
  overflow: 'hidden', // Prevent scrolling

}));

export default StyledMainBox;
